import { Component, Input, OnChanges } from '@angular/core';
import { Counter, Filter, Delay, Parallel, Reward, Sequential } from 'src/app/api/api-campaigns.service.generated';
import { MatTreeModule } from '@angular/material/tree';
import { ArrayDataSource } from '@angular/cdk/collections';
import { MatIconModule } from '@angular/material/icon';
import { FlatTreeControl } from '@angular/cdk/tree';
import { StepActionsComponent } from '../../step-actions/step-actions.component';

@Component({
  selector: 'app-strategy',
  templateUrl: './strategy.component.html',
  styleUrls: ['./strategy.component.scss'],
  imports: [
    StepActionsComponent,
    MatTreeModule,
    MatIconModule
  ]
})
export class StrategyComponent implements OnChanges {

  @Input() strategy: any;
  @Input() parent: any;

  filter: Filter;
  parallel: Parallel;
  sequential: Sequential;
  reward: Reward;
  delay: Delay;
  counter: Counter;

  strategyName = StrategyName;
  dataSource = new ArrayDataSource([]);

  treeControl = new FlatTreeControl<any>(
    node => node.level,
    node => node.expandable
  );

  Array = Array;
  parseInt = parseInt;

  constructor() { }


  ngOnChanges(): void {
    // const strategyChange = changes.strategy && (changes.strategy.previousValue != changes.strategy.currentValue);
    // if (strategyChange)
    this.setStrategy(this.strategy);

    // Flatten the strategy tree and set as data source
    if (this.strategy) {
      const flatStrategies = this.flattenStrategies(this.strategy);
      this.dataSource = new ArrayDataSource(flatStrategies);
    } else {
      this.dataSource = new ArrayDataSource([]);
    }
  }

  private flattenStrategies(strategy: any, level: number = 0): any[] {
    if (!strategy) return [];

    const result = [];
    const flatStrategy = {
      ...strategy,
      level: level,
      expandable: this.hasChildren(strategy)
    };

    result.push(flatStrategy);

    // Add nextStrategy as next level
    if (strategy.nextStrategy) {
      result.push(...this.flattenStrategies(strategy.nextStrategy, level + 1));
    }

    // Add children at next level
    if (strategy.children && strategy.children.length > 0) {
      strategy.children.forEach((child: any) => {
        result.push(...this.flattenStrategies(child, level + 1));
      });
    }

    return result;
  }

  private hasChildren(node: any): boolean {
    return !!(node.nextStrategy || (node.children && node.children.length > 0));
  }

  setStrategy(strategy: any): void {
    if (!strategy) return;

    switch (strategy.name) {
      case StrategyName.Filter:
        this.filter = strategy as Filter;
        break;
      case StrategyName.Reward:
        this.reward = strategy as Reward;
        break;
      case StrategyName.Parallel:
        this.parallel = strategy as Parallel;
        break;
      case StrategyName.Sequential:
        this.sequential = strategy as Sequential;
        break;
      case StrategyName.Delay:
        this.delay = strategy as Delay;
        break;
      case StrategyName.Counter:
        this.counter = strategy as Counter;
        break;
      default:
        break;
    }
  }

  hasChild = (_: number, node: any) => {
    return node.expandable || false;
  };

  canAdd(node: any): boolean {
    if(node.name === StrategyName.Filter || node.name === StrategyName.Delay ) {
      return !node.nextStrategy;
    } else if (node.name === StrategyName.Counter || node.name === StrategyName.Reward) {
      return false;
    } else if (node.name === StrategyName.Parallel || node.name === StrategyName.Sequential) {
      return true;
    } else {
      return !node.nextStrategy;
    }
  }
}

export enum StrategyName {
  Empty = 'Empty',      // used to bind a strategy that is not yet defined
  Filter = 'Filter',
  Reward = 'Reward',
  Parallel = 'Parallel',
  Sequential = 'Sequential',
  Delay = 'Delay',
  Counter = 'Counter'
}

export class EmptyStrategy {
  name: string;

  static new(): EmptyStrategy {
    return {
      name: StrategyName.Empty
    }
  }
}
